import LottieAnimation from './LottieAnimation';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import loader from '../assets/loader-lottie.json';
import { FunctionComponent } from 'react';

export type LoaderType = {
  width?: string;
  height?: string;
};

export type LoaderComponentType = FunctionComponent<LoaderType>;

export const Loader: LoaderComponentType = ({ width = '100%', height = '100%' }: LoaderType) => {
  return <LottieAnimation animation={loader} width={width} height={height} />;
}
export default Loader;
